/* Demo-floor data for the MDT Department view (no token = preview mode). */

export const DEMO_CONFIG = {
  departments: [
    { id: "d-pol", name: "Police Department", abbr: "BPD", type: "police", color: "#38bdf8",
      subdepartments: [{ id: "s-pat", name: "Patrol" }, { id: "s-tra", name: "Traffic Division" }, { id: "s-det", name: "Detective Bureau" }, { id: "s-swat", name: "SWAT" }],
      ranks: [
        { id: "r1", name: "Cadet", level: 1, is_supervisor: false, is_command: false },
        { id: "r2", name: "Officer", level: 2, is_supervisor: false, is_command: false },
        { id: "r3", name: "Senior Officer", level: 3, is_supervisor: false, is_command: false },
        { id: "r4", name: "Sergeant", level: 4, is_supervisor: true, is_command: false },
        { id: "r5", name: "Lieutenant", level: 5, is_supervisor: true, is_command: false },
        { id: "r6", name: "Captain", level: 6, is_supervisor: false, is_command: true },
        { id: "r7", name: "Deputy Chief", level: 7, is_supervisor: false, is_command: true },
        { id: "r8", name: "Chief of Police", level: 8, is_supervisor: false, is_command: true },
      ] },
    { id: "d-ems", name: "Emergency Medical Services", abbr: "EMS", type: "ems", color: "#34d399",
      subdepartments: [{ id: "s-med", name: "Field Medics" }, { id: "s-hos", name: "Hospital Staff" }],
      ranks: [
        { id: "e1", name: "Trainee", level: 1, is_supervisor: false, is_command: false },
        { id: "e2", name: "Paramedic", level: 2, is_supervisor: false, is_command: false },
        { id: "e3", name: "Supervisor", level: 3, is_supervisor: true, is_command: false },
        { id: "e4", name: "Chief", level: 4, is_supervisor: false, is_command: true },
      ] },
    { id: "d-fd", name: "Fire & Rescue", abbr: "FD", type: "fire", color: "#fb923c",
      subdepartments: [{ id: "s-eng", name: "Engine Company" }, { id: "s-res", name: "Rescue Company" }],
      ranks: [
        { id: "f1", name: "Probationary", level: 1, is_supervisor: false, is_command: false },
        { id: "f2", name: "Firefighter", level: 2, is_supervisor: false, is_command: false },
        { id: "f3", name: "Lieutenant", level: 3, is_supervisor: true, is_command: false },
        { id: "f4", name: "Fire Chief", level: 4, is_supervisor: false, is_command: true },
      ] },
  ],
};

export const DEMO_ROSTER = [
  { playercode: 37049, name: "Officer Reyes", dept_name: "Police Department", dept_id_current: "d-pol", rank: DEMO_CONFIG.departments[0].ranks[1], joined_at: "2026-07-02T10:00:00Z", reviews: [{ id: "rv1", by: "Sgt. Okafor", by_rank: "Sergeant", text: "Solid radio discipline, keeps scene notes clean.", rating: 4, at: "2026-09-10T22:00:00Z" }] },
  { playercode: 22110, name: "Ada King", dept_name: "Police Department", dept_id_current: "d-pol", rank: DEMO_CONFIG.departments[0].ranks[3], joined_at: "2026-05-11T10:00:00Z", reviews: [] },
  { playercode: 90221, name: "M. Delgado", dept_name: "Emergency Medical Services", dept_id_current: "d-ems", rank: DEMO_CONFIG.departments[1].ranks[1], joined_at: "2026-06-20T10:00:00Z", reviews: [] },
  { playercode: 61008, name: "R. Walsh", dept_name: "Fire & Rescue", dept_id_current: "d-fd", rank: DEMO_CONFIG.departments[2].ranks[1], joined_at: "2026-08-01T10:00:00Z", reviews: [] },
];

export const DEMO_LAWS = [
  { id: "l1", code: "INF-01", title: "Speeding", class: "infraction", fine: 250, jail_seconds: 0, points: 2, description: "Operating a vehicle above the posted limit." },
  { id: "l2", code: "MIS-02", title: "Driving Under the Influence", class: "misdemeanor", fine: 1200, jail_seconds: 600, points: 5, description: "Operating a vehicle while intoxicated." },
  { id: "l3", code: "MIS-07", title: "Resisting Arrest", class: "misdemeanor", fine: 1000, jail_seconds: 600, points: 3, description: "Non-violent refusal to comply with lawful detention." },
  { id: "l4", code: "FEL-01", title: "Grand Theft Auto", class: "felony", fine: 5000, jail_seconds: 3600, points: 8, description: "Theft of a motor vehicle." },
  { id: "l5", code: "FEL-02", title: "Armed Robbery", class: "felony", fine: 8000, jail_seconds: 5400, points: 10, description: "Theft by force or threat with a deadly weapon." },
  { id: "l6", code: "FEL-04", title: "Attempted Murder", class: "felony", fine: 15000, jail_seconds: 7200, points: 12, description: "Deliberate attempt to take a life." },
];

export const DEMO_SOPS = [
  { id: "so1", title: "Pursuit SOP", dept_id: "d-pol", author: "Chief Marlowe", updated_at: "2026-09-01T12:00:00Z", body: "1. Never pursue solo — wait for a second unit.\n2. Call out location and direction on the patrol channel every 10 seconds.\n3. Command may terminate the pursuit at any time.\n4. No PIT manoeuvres above 60 mph without supervisor approval." },
  { id: "so2", title: "Use of Force Continuum", dept_id: "", author: "Chief Marlowe", updated_at: "2026-08-20T12:00:00Z", body: "Presence → Verbal → Less-lethal → Lethal.\nAlways announce before escalating. Medical must be requested the moment a scene is code 4." },
];

export const DEMO_EXAMS = [
  { id: "ex1", title: "Sergeant Board Exam", dept_id: "d-pol", pass_mark: 70, created_by: "Chief Marlowe", created_at: "2026-09-05T12:00:00Z",
    questions: [
      { id: "q1", q: "What does 10-8 mean?", options: ["Available", "Busy", "Off duty", "On scene"] },
      { id: "q2", q: "First priority on any scene?", options: ["Paperwork", "Life safety", "Traffic control", "Media statement"] },
      { id: "q3", q: "Who may terminate a pursuit?", options: ["Any cadet", "Command only", "The suspect", "Nobody"] },
    ] },
];

export const DEMO_EXAM_RESULTS = [
  { id: "er1", exam_title: "Sergeant Board Exam", name: "Ada King", playercode: 22110, score: 100, passed: true, at: "2026-09-12T18:00:00Z" },
  { id: "er2", exam_title: "Sergeant Board Exam", name: "Officer Reyes", playercode: 37049, score: 33, passed: false, at: "2026-09-13T18:00:00Z" },
];

export const DEMO_TRANSFERS = [
  { id: "tr1", name: "M. Delgado", playercode: 90221, from_dept: "Emergency Medical Services", to_dept: "Police Department", reason: "Cross-training into the Detective Bureau.", status: "pending", at: "2026-09-15T09:00:00Z" },
];

export const DEMO_WARRANTS = [
  { id: "w1", name: "Dwight Kingsley", playercode: 77003, reason: "Armed robbery of the 24/7 — armed and dangerous", serious: true, funds_locked: true, issued_by: "Sgt. Okafor", at: "2026-09-16T21:00:00Z", signed_by: "R. Castellanos" },
  { id: "w2", name: "A. O'Connor", playercode: 11884, reason: "Chop-shop ring — felony GTA x3", serious: false, funds_locked: false, issued_by: "Officer Reyes", at: "2026-09-17T08:00:00Z" },
];

export const DEMO_SUBPOENAS = [
  { id: "sp1", target_name: "Dwight Kingsley", target_playercode: 77003, reason: "Coordinating robberies by text.", requester_name: "Sgt. Okafor", status: "approved", decided_by: "Chief Marlowe", at: "2026-09-14T10:00:00Z" },
  { id: "sp2", target_name: "A. O'Connor", target_playercode: 11884, reason: "Suspect in chop-shop ring.", requester_name: "Officer Reyes", status: "pending", at: "2026-09-16T14:00:00Z" },
];

export const DEMO_CHANNELS = [
  { id: "c1", label: "DISPATCH", channel: "1" }, { id: "c2", label: "PATROL PRIMARY", channel: "44" },
  { id: "c3", label: "PATROL SECONDARY", channel: "45" }, { id: "c4", label: "SWAT / TAC", channel: "34" },
  { id: "c5", label: "DETECTIVES", channel: "31" }, { id: "c6", label: "EMS", channel: "22" },
];

export const DEMO_SUBPOENA_RECORDS = {
  messages: [
    { from_name: "Dwight Kingsley", to_pc: 11884, body: "truck's ready, bring the plates", at: "2026-09-15T22:10:00Z" },
    { from_name: "A. O'Connor", to_pc: 77003, body: "half up front, half when it's done", at: "2026-09-15T22:14:00Z" },
  ],
  calls: [{ caller_pc: 77003, callee_pc: 11884, status: "ended", at: "2026-09-15T22:08:00Z" }],
};

export const DEMO_BEATS = [
  { id: "bt1", name: "CRESTWOOD", color: "#f472b6", zone: { x1: -700, y1: 4900, x2: 100, y2: 5600 }, shift: "Night", units: ["1-L-12", "1-A-01"], created_by: "Chief Marlowe" },
  { id: "bt2", name: "DOWNTOWN", color: "#38bdf8", zone: { x1: -260, y1: -1700, x2: 380, y2: -950 }, shift: "All shifts", units: ["1-L-07"], created_by: "Chief Marlowe" },
];

export const DEMO_CHAT = [
  { id: "m1", author: "DISPATCH", body: "All units — shift change in 15, finish your paperwork.", at: "2026-09-17T03:40:00Z" },
  { id: "m2", author: "1-L-12", body: "Copy. Crestwood beat covered, one traffic stop pending.", at: "2026-09-17T03:42:00Z" },
  { id: "m3", author: "1-A-01", body: "Air-1 refuelling, back over the city in 5.", at: "2026-09-17T03:44:00Z" },
];

export const DEMO_NOTES = [
  { id: "n1", author: "1-L-12", body: "Scene secure. Two witnesses held for statements.", at: "2026-09-17T03:10:00Z" },
  { id: "n2", author: "1-L-07", body: "K9 track went cold at the canal. Recommend BOLO stays active.", at: "2026-09-17T03:26:00Z" },
];
